// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__vJy4r","close":"Modal_close__ittVe"};